import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import {useTranslation} from 'react-i18next';
import MetricsInspectionColumn from '../MetricsInspectionColumn';
import {
  useLazyMetricsUpcomingInspectionsQuery,
  useGetFacilityQuery,
  useGetEquipmentTypeQuery,
} from '../../../store/builder/inspections.api';

const selectStyles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
    borderRadius: 8,
    width: 180,
    height: 30,
    fontSize: 14,
    backgroundColor: '#FFFFFF',
    color: '#718096',
  }),
};

const UpcomingInspectionsTable = ({agency, title}) => {
  const {t} = useTranslation();

  const [facilityOptions, setFacilityOptions] = useState([]);
  const [equipmentTypeOptions, setEquipmentTypeOptions] = useState([]);
  const [facilityValue, setFacilityValue] = useState(null);
  const [equipmentValue, setEquipmentValue] = useState(null);

  const {data: facilityData, isSuccess: facilityIsSuccess} =
    useGetFacilityQuery();
  const {data: equipmentTypesData, isSuccess: equipmentTypesIsSuccess} =
    useGetEquipmentTypeQuery();

  const [getMetricsUpcomingInspection, {data}] =
    useLazyMetricsUpcomingInspectionsQuery();

  useEffect(() => {
    if (equipmentTypesIsSuccess) {
      setEquipmentTypeOptions([
        {value: null, label: t('advancedMetrics.all')},
        ...(equipmentTypesData?.map(item => ({
          value: item?.id,
          label: item?.title,
        })) ?? []),
      ]);
    }
    if (facilityIsSuccess) {
      setFacilityOptions([
        {value: null, label: t('advancedMetrics.all')},
        ...(facilityData?.map(item => ({
          value: item?.id,
          label: item?.name,
        })) ?? []),
      ]);
    }
  }, [
    equipmentTypesIsSuccess,
    facilityIsSuccess,
    t,
    equipmentTypesData,
    facilityData,
  ]);

  useEffect(() => {
    if (agency) {
      getMetricsUpcomingInspection({
        agency: agency,
        facility_id: facilityValue,
        equipment_id: equipmentValue,
      });
    }
  }, [agency, facilityValue, equipmentValue]);

  const tableTitle = title ?? t('advancedMetrics.tableUpcomingInspections');
  const facilityOption =
    facilityOptions.find(o => o.value === facilityValue) ?? null;
  const equipmentOption =
    equipmentTypeOptions.find(o => o.value === equipmentValue) ?? null;

  return (
    <div className='metrics__block'>
      <div className='chart w-100'>
        <div className='chart__header'>
          <p className='chart__header-title w-290'>{tableTitle}</p>

          <div className='chart__header-filters'>
            <Select
              placeholder={t('advancedMetrics.facility')}
              options={facilityOptions}
              styles={selectStyles}
              onChange={e => setFacilityValue(e?.value)}
              value={facilityOption}
            />

            <Select
              placeholder={t('advancedMetrics.equipmentType')}
              options={equipmentTypeOptions}
              styles={selectStyles}
              value={equipmentOption}
              onChange={e => setEquipmentValue(e?.value)}
            />
          </div>
        </div>
        <div className='chart__box metrics-table'>
          <MetricsInspectionColumn
            title={t('advancedMetrics.monthly')}
            type='monthly'
            data={data?.monthly}
          />
          <MetricsInspectionColumn
            title={t('advancedMetrics.quarterly')}
            type='quarterly'
            data={data?.quarterly}
          />
          <MetricsInspectionColumn
            title={t('advancedMetrics.semiannual')}
            type='semi'
            data={data?.semiannual}
          />
          <MetricsInspectionColumn
            title={t('advancedMetrics.annual')}
            type='annual'
            data={data?.annual}
          />
        </div>
      </div>
    </div>
  );
};

export default UpcomingInspectionsTable;
